/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';
require('./bootstrap');
import Vue from 'vue';

window.Vue = require('vue');

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  loading: '/img/icon/loading-spin.svg',
});

import Toasted from 'vue-toasted';
Vue.use(Toasted);

const VueInputMask = require('vue-inputmask').default;
Vue.use(VueInputMask);

const FocusLock = require('vue-focus-lock').default;
Vue.component('focus-lock', FocusLock);

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDC4jwxkq-jV-EUiNWvVSqsQ9LhAYR32-A',
    libraries: 'places',
  },
});

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

Vue.prototype.$disableBodyScroll = disableBodyScroll;
Vue.prototype.$enableBodyScroll = enableBodyScroll;
Vue.prototype.$clearAllBodyScrollLocks = clearAllBodyScrollLocks;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component(
  'business-list',
  require('./components/BusinessList.vue').default,
);
Vue.component(
  'tag-business-list',
  require('./components/TagBusinessList.vue').default,
);
Vue.component(
  'featured-category-carousel',
  require('./components/FeaturedCategoryCarousel.vue').default,
);
Vue.component(
  'postal-code',
  require('./components/PostalCode.vue').default,
);
Vue.component(
  'featured-business-carousel',
  require('./components/FeaturedBusinessCarousel.vue').default,
);
Vue.component('menu-toggle', require('./components/MenuToggle.vue').default);
Vue.component(
  'business-form',
  require('./components/BusinessForm.vue').default,
);
Vue.component('contact-form', require('./components/ContactForm.vue').default);
Vue.component('listing-form', require('./components/ListingForm.vue').default);
Vue.component('google-map', require('./components/GoogleMap.vue').default);
Vue.component('modal', require('./components/Modal.vue').default);
Vue.component(
  'header-content',
  require('./components/HeaderContent.vue').default,
);
Vue.component(
  'header-search',
  require('./components/HeaderSearch.vue').default,
);
Vue.component(
  'photo-gallery',
  require('./components/PhotoGallery.vue').default,
);
Vue.component(
  'sidebar-content',
  require('./components/SidebarContent.vue').default,
);

const app = new Vue({
  el: '#app',
});
